import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu";
import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { NavigationMenuIndicatorProps } from "../types";

function NavigationMenuIndicator({
  className,
  ...props
}: NavigationMenuIndicatorProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <NavigationMenuPrimitive.Indicator
      data-slot="navigation-menu-indicator"
      className={cn(
        "data-[state=visible]:animate-in data-[state=hidden]:animate-out data-[state=hidden]:fade-out data-[state=visible]:fade-in top-full z-[1] flex h-1.5 items-end justify-center overflow-hidden",
        className,
        classes,
      )}
      {...native}
    >
      <div className="bg-border relative top-[60%] h-2 w-2 rotate-45 rounded-tl-sm shadow-md" />
    </NavigationMenuPrimitive.Indicator>
  );
}

NavigationMenuIndicator.displayName = "NavigationMenp.Indicator";

export default NavigationMenuIndicator;
